import moment from 'moment-timezone';

export const timeFormat = (time) => {
    let date = timeZone(time);
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    const D = date.getDate();
    const Y = date.getFullYear();
    let changeTime = M + '/' + addZero(D) + '/' + Y;
    return changeTime;
}
export const timeFormat2 = (time) => {
    let date = timeZone(time);
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    const D = date.getDate();
    const Y = date.getFullYear();
    let changeTime = Y + "-" + M + "-" + addZero(D);
    return changeTime;
}
export const format2ToTimestamp = (date) => {
    return (Date.parse(date) / 1000).toString();
};
export const timeFormatS = (time) => {
    let date = localTime(time);
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    const D = date.getDate();
    const Y = date.getFullYear();
    const h = date.getHours();
    const m = date.getMinutes();
    const s = date.getSeconds();
    let changeTime = M + '/' + addZero(D) + '/' + Y + ' ' + addZero(h) + ':' + addZero(m) + ':' + addZero(s);
    return changeTime;
}
export const localTimeFormatS = (time) => {
    let date = time ? new Date(time) : new Date();
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    const D = date.getDate();
    const Y = date.getFullYear();
    const h = date.getHours();
    const m = date.getMinutes();
    const s = date.getSeconds();
    return M + '/' + addZero(D) + '/' + Y + ' ' + addZero(h) + ':' + addZero(m) + ':' + addZero(s);
};
export const getNowDate = (time = null) => {
    let date = time ? new Date(time) : new Date();
    let dateString = new Date(date.getTime()).toISOString().split("T")[0];
    return dateString;
}
export const getToday = () => {
    const today = new Date();
    const M = today.getMonth() + 1;
    const D = today.getDate();
    const Y = today.getFullYear();
    return Y + "-" + addZero(M) + "-" + addZero(D);
}
function timeZone(time) {
    let localDate = time ? new Date(time) : new Date();
    let localTime = localDate.getTime();
    let localOffset = localDate.getTimezoneOffset() * 60 * 1000;
    let date = new Date(localTime + localOffset);
    return date;
}
function localTime(time) {
    let localDate = time ? new Date(time) : new Date();
    let localTime = localDate.getTime();
    let date = new Date(localTime);
    return date;
}

function addZero(m) {
    return m < 10 ? '0' + m : m;
}

export const getAge = (strBirthday) => {
    let returnAge;
    let strBirthdayArr = strBirthday.split("-");
    let birthYear = strBirthdayArr[0];
    let birthMonth = strBirthdayArr[1];
    let birthDay = strBirthdayArr[2];

    let d = new Date();
    let nowYear = d.getFullYear();
    let nowMonth = d.getMonth() + 1;
    let nowDay = d.getDate();

    if (nowYear === birthYear) {
        returnAge = 0;//同年 则为0岁
    } else {
        let ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth === birthMonth) {
                let dayDiff = nowDay - birthDay;//日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                let monthDiff = nowMonth - birthMonth;//月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge;//返回周岁年龄
}
//根据key从对象数组中取出obj
export const getObjByName = (objArr, key, name) => {
    return objArr.find((element) => (element[key] === name));
}
//根据key从对象数组中取出obj
export const getObjByName2 = (objArr, key1, key2, name) => {
    return objArr.find((element) => (element[key1][key2] === name));
}
//对象数组去重
export const deduplicationObjArr = (objArr, key) => {
    const newMap = new Map();
    const deduplicationObjArr = objArr.filter((obj) => !newMap.has(obj[key]) && newMap.set(obj[key], 1));
    return deduplicationObjArr;
}
//对象数组去重 筛选条件：对象数组中对象内的对象
export const deduplicationObjArr2 = (objArr, key, key2) => {
    const newMap = new Map();
    const deduplicationObjArr = objArr.filter((obj) => !newMap.has(obj[key][key2]) && newMap.set(obj[key][key2], 1));
    return deduplicationObjArr;
}
//转换成金额显示
export const toMoney = (num) => {
    num = Number(num);
    if (isNaN(num)) num = 0;
    num = num.toFixed(2);
    num = parseFloat(num)
    num = num.toLocaleString();
    let rs = num.indexOf('.');
    if (rs < 0) {
        rs = num.length;
        num += '.';
    }
    while (num.length <= rs + 2) {
        num += '0';
    }
    return num;
}

export const cutString = (str, len = 10) => {
    //length属性读出来的汉字长度为1 
    if (str.length * 2 <= len) {
        return str;
    }
    let strlen = 0;
    let s = "";
    for (let i = 0; i < str.length; i++) {
        s = s + str.charAt(i);
        if (str.charCodeAt(i) > 128) {
            strlen = strlen + 2;
            if (strlen >= len) {
                return s.substring(0, s.length - 1) + "...";
            }
        } else {
            strlen = strlen + 1;
            if (strlen >= len) {
                return s.substring(0, s.length - 2) + "...";
            }
        }
    }
    return s;
}
export const egdeCollisions = (rect1, rect2) => {
    if (!rect1 || !rect2) return false;
    if (rect1.left < rect2.left + rect2.width &&
        rect1.left + rect1.width > rect2.left &&
        rect1.top < rect2.top + rect2.height &&
        rect1.height + rect1.top > rect2.top) {
        return true;
    } else {
        return false;
    }
}
export const clone = (origin) => {
    return JSON.parse(JSON.stringify(origin));
}

export const conver = (limit) => {
    let size = "";
    if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else { //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }

    let sizestr = size + "";
    const len = sizestr.indexOf(".");
    const dec = sizestr.substr(len + 1, 2);
    if (dec === "00") {//当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
    }
    return sizestr;
}

export const getMonthName = (num) => {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    return monthNames[num];
};

export const validateEmail = (email) => {
    const re = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const getUTCTimestamp = (dateStr) => {
    if (dateStr === null) {
        dateStr = moment().format('yyyy-MM-DD')
    }
    return moment.utc(dateStr).format('X');
};


export const newId = () => {
    return Math.random().toString(36).slice(-6);
}

export const getUrlParams = (name) => {
    let search = window.location.search.substring(1);
    if (search) {
        let obj = JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
        return name ? obj[name] : obj
    }
    return '';
}